import { apiClient } from "@/api/api-client";
import FloatingAction from "@/components/core/actions/floating-action";
import { Button } from "@/components/core/buttons/button";
import { Content } from "@/components/layouts/content";
import IncomingCases from "@/features/case-evaluation/incoming-cases";
import { caseRecordTotalQueryOptions } from "@/features/case-record/api/queries/case-record-statistic-query";
import CaseStageChart from "@/features/overview/components/case-stage-chart";
import CaseStats from "@/features/overview/components/case-stats";
import StatCard from "@/features/overview/components/stat-card";
import UpcomingEvents from "@/features/overview/components/upcoming-events";
import { useAuth } from "@/hooks/use-auth";
import { createFileRoute } from "@tanstack/react-router";

import { useEffect, useState } from "react";

export const Route = createFileRoute("/_dashboard/judge-dashboard")({
	component: RouteComponent,
});

function RouteComponent() {
	const { user } = useAuth();
	const [tatolCases, setTotalCases] = useState(0);
	const [breakdown, setBreakdown] = useState(0);

	const fetchCaseCount = async () => {
		const response = await apiClient.get("/backoffice/case-records-total");
		setTotalCases(response.data);
	};

	const fetchCaseRecordBreakdown = async () => {
		const response = await apiClient.get("/backoffice/case-records-breakdown");
		setBreakdown(response.data);
	};

	useEffect(() => {
		fetchCaseCount();
		fetchCaseRecordBreakdown();
	}, []);

	return (
		<Content>
			<div className="flex flex-col w-full max-w-base p-6 gap-4">
				<div className="flex flex-col w-full">
					<span className="text-xl text-foreground-dark font-semibold">
						Welcome {user?.first_name},
					</span>
					<span className="text-base text-foreground/70">
						View assigned cases and updates
					</span>
				</div>
				<div className="flex flex-col w-full h-full gap-4">
					{/* <StatCard /> */}

					<div className="grid grid-cols-12 w-full gap-4">
						<div className="col-span-12">
							<div className="flex flex-col w-full gap-4">
								<div className="flex flex-col w-full h-auto rounded-md border border-border/50 overflow-hidden">
									<div className="flex flex-row w-full p-3 border-b border-border/50">
										<span className="text-base font-semibold text-foreground-dark">
											Total Cases ({tatolCases})
										</span>
									</div>
									<div className="flex flex-col w-full h-full shrink-0">
										{breakdown && <CaseStats items={breakdown} />}
									</div>
								</div>
								{/* <div className="flex flex-col w-full h-full rounded-md border border-border/50 overflow-hidden">
									<div className="flex flex-row w-full p-3 border-b border-border/50">
										<span className="text-base font-semibold text-foreground-dark">
											Filed Cases Comparison
										</span>
									</div>
									<div className="flex flex-col w-full">
										<CaseStageChart />
									</div>
								</div> */}
							</div>
						</div>
						{/*<div className="col-span-4">
							<div className="flex flex-col w-full h-full rounded-md border border-border/50 overflow-hidden">
								<div className="flex flex-row w-full p-3 border-b border-border/50">
									<span className="text-base font-semibold text-foreground-dark">
										Upcoming Events
									</span>
								</div>
								<div className="flex flex-col w-full h-ful overflow-y-auto">
									<UpcomingEvents />
								</div>
							</div>
						</div>*/}
					</div>
					<div className="flex flex-col w-full h-full rounded-md border border-border/50 overflow-hidden">
						<div className="flex flex-row w-full p-3 border-b border-border/50">
							<span className="text-base font-semibold text-foreground-dark">
								Incoming Cases
							</span>
						</div>
						<div className="flex flex-col w-full">
							{/* TODO fix for judge*/}
							{/* <IncomingCases /> */}
						</div>
					</div>
				</div>
				{/* <FloatingAction
					title="Quick Actions"
					description="Choose an action below"
					actions={[
						{
							label: "Receive this case",
							variant: "green",
							onClick: () => alert("Submit clicked"),
						},
					]}
				/> */}
			</div>
		</Content>
	);
}
